import React from 'react';

import 'sass/form/submit-wrapper.scss';

export default function SubmitWrapper(props) {
    let {className} = props;

    if (props.pending) {
        return (
            <div className={className + ' btn-submit-wrapper submit-pending'}>
                <div className="dot1"/>
                <div className="dot2"/>
                <div className="dot3"/>
            </div>
        )
    } else {
        let {value} = props;

        return (
            <input type="submit" className={className + ' btn-submit-wrapper'} value={value}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/form/SubmitWrapper.js